const styles = {
  container: {
    borderRadius: 2,
    fontFamily: 'verdana',
    background: '#fff',
    padding: 3,
    border: '1px solid #ccc',
    cursor: 'pointer',
    display: 'flex',
    flexWrap: 'wrap'
  },
  noneEditableContainer: {
    display: 'flex',
    fontFamily: 'verdana',
    background: '#fff',
    flexWrap: 'wrap'
  }
}

export default styles
